/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_CreatedInputs */

const en_admin_permissions_created = /** @type {(inputs: Admin_Permissions_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission created`)
};

/**
* | output |
* | --- |
* | "Permission created" |
*
* @param {Admin_Permissions_CreatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_permissions_created = /** @type {((inputs?: Admin_Permissions_CreatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_CreatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_permissions_created(inputs)
});
export { admin_permissions_created as "admin.permissions.created" }